import { useCallback } from 'react'
import type { IAutoReviewAdditionalField } from '@user/store/autoReviewSettings'
import type { UseData } from './useData'

type Props = {
  handleAddFields: (selection: IAutoReviewAdditionalField[]) => void
  handleRemoveField: (field: IAutoReviewAdditionalField) => void
}

export const useHandlers = (data: UseData, props: Props) => {
  const { setDialogOpen } = data
  const { handleAddFields, handleRemoveField } = props

  const openDialog = useCallback(() => setDialogOpen(true), [setDialogOpen])

  const closeDialog = useCallback(() => setDialogOpen(false), [setDialogOpen])

  const handleAdd = useCallback(
    (selection: IAutoReviewAdditionalField[]) => {
      handleAddFields(selection)
      setDialogOpen(false)
    },
    [handleAddFields, setDialogOpen],
  )

  const handleRemove = useCallback(
    (field: IAutoReviewAdditionalField) => () => handleRemoveField(field),
    [handleRemoveField],
  )

  return { openDialog, closeDialog, handleAdd, handleRemove }
}
